export enum WorkerFormStatusEnum {
  Draft = 1,
  Approved = 2,
}
